import * as tslib_1 from "tslib";
import { Component, Prop, } from 'vue-property-decorator';
import { BaseControl } from '../../controls';
import { Tabs } from '@h3/antd-vue';
import * as typings from '@cloudpivot/form/schema';
let FormTabs = class FormTabs extends BaseControl {
    constructor() {
        super(...arguments);
        this.activeKey = '';
    }
    created() {
        if (this.ctrl && this.ctrl.value) {
            this.activeKey = this.ctrl.value;
        }
        else {
            this.activeKey = this.defaultActiveKey;
        }
        if (this.ctrl) {
            this.setValue(this.activeKey);
        }
    }
    handleChange(key) {
        this.setValue(key);
    }
    handleValueChange() {
        console.log('值变化时我执行了', this.ctrl ? this.ctrl.value : '空');
        this.activeKey = this.ctrl ? this.ctrl.value : '-1';
        typings.EventBus.$emit('activeKey', {
            data: this.activeKey,
        });
    }
};
tslib_1.__decorate([
    Prop({
        default: '-1',
    })
], FormTabs.prototype, "defaultActiveKey", void 0);
FormTabs = tslib_1.__decorate([
    Component({
        name: 'form-tabs',
        components: {
            ATabs: Tabs,
            ATabPane: Tabs.TabPane,
        },
    })
], FormTabs);
export default FormTabs;
